import auth from './auth'
import staff from './staff'
import PurchasedCard from './OrderCard'
import Procurement from './procurement'
import product from './product'
import inventory from './inventory'
import accounts from './accounts'
import store from './store'
import salesOrder from './salesOrder'
import report from './report'
import brand from './brand'
import dashboard from './dashboard'
import settingTab from './setting'
import barcode from './barcode'
import lensDetails from "./lensDetails"
import sku from "./sku"
import internalTransfer from './internalTransfer'
import fittingLab from "./fittingLab"
import eCommerce from "./eCommerce"
import roles from './roles'
import warranty from "./warranty"
import movement from "./movement"

const dictionary = {
  auth,
  staff,
  PurchasedCard,
  Procurement,
  product,
  inventory,
  accounts,
  store,
  salesOrder,
  report,
  brand,
  dashboard,
  settingTab,
  barcode,
  lensDetails,
  sku,
  internalTransfer,
  fittingLab,
  eCommerce,
  roles,
  warranty,
  movement
}
export default dictionary
